"use client";
import SectionHeader from "@/components/common/section-header";
import useInViewPort from "@/hooks/useInViewport";
import Image from "next/image";
import { FC, ReactNode, useEffect, useState } from "react";
import RespectImg from "@/../public/images/abstract/values/RESPECT.png";
import SelfControlImg from "@/../public/images/abstract/values/SELF-CONTROL.png";
import WisdomImg from "@/../public/images/abstract/values/WISDOM.png";
import ResponsabilityImg from "@/../public/images/abstract/values/RESPONSABILITY.png";
import HonestyImg from "@/../public/images/abstract/values/HONESTY.png";

import { ourValuesEN } from "@/assets/dictionaries/en/about-content";
import { ourValuesES } from "@/assets/dictionaries/es/about-content";

const Value: FC<{ children: ReactNode; icon: ReactNode }> = ({
  children,
  icon,
}) => {
  const { ref, isInViewport } = useInViewPort<HTMLDivElement>({ once: true });

  return (
    <div
      className={`flex-1 min-w-fit xl:min-w-[45%] flex gap-4 max-w-md ${isInViewport ? "animate-fadein" : "opacity-0"}`}
      ref={ref}
    >
      <div className="relative w-[80px] h-[80px]">{icon}</div>
      <p className="flex-1 text-xl">{children}</p>
    </div>
  );
};

const OurValues: FC = () => {
  const [ourValuesContent, setOurValuesContent] = useState(ourValuesEN); // Default to English

  useEffect(() => {
    // Get the language from localStorage
    const lang = localStorage.getItem("selectedOption") || "EN"; // Default to EN if not found

    // Set the content based on the language
    switch (lang.toUpperCase()) {
      case "ES":
        setOurValuesContent(ourValuesES);
        break;
      case "EN":
      default:
        setOurValuesContent(ourValuesEN);
        break;
    }
  }, []);
  return (
    <section className="px-page-xl py-16">
      <SectionHeader>{ourValuesContent.title_section}</SectionHeader>

      <div className="flex flex-wrap items-center pt-8 gap-8 justify-between text-justify">
        <Value icon={<Image src={RespectImg} alt="Respect" />}>
          <strong>{ourValuesContent.respect}</strong>{" "}
          {ourValuesContent.respect_desc}
        </Value>

        <Value icon={<Image src={SelfControlImg} alt="Selfcontrol" />}>
          <strong>{ourValuesContent.self_control}</strong>{" "}
          {ourValuesContent.self_control_desc}
        </Value>

        <Value icon={<Image src={WisdomImg} alt="Wisdom" />}>
          <strong>{ourValuesContent.wisdom}</strong>{" "}
          {ourValuesContent.wisdom_desc}
        </Value>

        <Value icon={<Image src={ResponsabilityImg} alt="Responsibility" />}>
          <strong>{ourValuesContent.responsibility}</strong>{" "}
          {ourValuesContent.responsibility_desc}
        </Value>

        <Value icon={<Image src={HonestyImg} alt="Honesty" />}>
          <strong>{ourValuesContent.honesty}</strong>{" "}
          {ourValuesContent.honesty_desc}
        </Value>
      </div>
    </section>
  );
};

export default OurValues;
